import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Card as BaseCard } from '@leroy-merlin-br/backyard-react-ui'

export const cardStyles = ({ theme }) => css`
  label: accordion__card;

  ${theme.media.mega} {
    padding: ${theme.spacings.mega} 0;

    & > div {
      padding: 0 0 0 ${theme.spacings.mega};
      overflow-y: hidden;
    }
  }
`

const headerStyles = ({ theme }) => css`
  label: accordion__header;

  display: flex;
  justify-content: space-between;
  align-items: center;

  cursor: pointer;

  ${theme.media.mega} {
    padding-right: ${theme.spacings.tera};
  }

  & > svg {
    color: ${theme.colors.n600};
  }
`

const contentStyles = () => css`
  label: accordion__content;

  max-height: 0;
  transition: .6s ease;
  overflow: hidden;
`

const contentOpenStyles = ({ theme, isOpen, openHeight }) =>
  isOpen &&
  css`
    label: accordion__content--open;

    margin-top: ${theme.spacings.kilo};
    max-height: ${openHeight}px;
  `

export const Card = styled(BaseCard)(cardStyles)
export const Header = styled('div')(headerStyles)
export const Content = styled('div')(contentStyles, contentOpenStyles)
